import { useEffect } from 'react';

import { LOGIN } from '@/constants/routes';
import { useMagicLinkInit } from '@/hooks/queries/useMagicLinkInit';
import { useUrlState } from '@/hooks/useUrlState';

export function useMagicLinksInit() {
  const { history } = useUrlState();
  const path = history.location.pathname
    ? history.location.pathname.substring(1)
    : null;
  const { data, isError } = useMagicLinkInit(path);

  useEffect(() => {
    if (!path) {
      return;
    }
    if (data?.link) {
      window.location.href = data.link;
      return;
    }
    if (isError || data) {
      history.push(LOGIN);
    }
  }, [data, isError, history, path]);
}
